<template>
  <form-group v-bind="$attrs">
    <form-group
      class="ma-0 pa-0"
      title="Grade valores"
    >
      <v-divider />
    </form-group>
    <v-row
      v-for="(item, idx) in items"
      :key="`rows_${idx}`"
      :class="idx === 0 ? 'mt-6': ''"
    >
      <v-col :cols="defineCols()">
        <input-text
          :id="`nomItem_${idx}`"
          v-model="items[idx].nomItem"
          label="Nome do item"
        />
      </v-col>
      <v-col :cols="defineCols()">
        <input-money
          :id="`vlrItem_${idx}`"
          v-model="items[idx].vlrItem"
          label="Valor"
          :rules="[requiredRule]"
          required
        />
      </v-col>
      <v-col
        v-if="isRo"
        cols="4"
      >
        <v-combobox
          :id="`ddd_${idx}`"
          v-model="ddds[idx]"
          label="DDD's"
          :rules="[requiredRule]"
          :items="dddOptions"
          multiple
          outlined
          clearable
          required
        />
      </v-col>
      <v-col cols="2">
        <remove-add-buttons
          v-model="items"
          :position="idx"
          @remove="removeItem($event)"
          @add="addItem()"
        />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import Ddds from '@/app/arch/enums/Ddds';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import RemoveAddButtons from '@/app/arch/components/Buttons/RemoveAddButtons.vue';
import ProdutoGradeRequest from '../../grade/ProdutoGradeRequest';

const produtoServicoGradeDdds = [
  {
    ddd: '',
    id: '',
  },
];

const itemListaValor = {
  idProdutoServico: '',
  nomItem: '',
  vlrItem: '',
  produtoServicoGradeDdds,
  id: '',
};

const listaValoresGrade = [
  itemListaValor,
];

export default {
  name: 'ProdutoGradeValores',
  components: { FormGroup, RemoveAddButtons },
  mixins: [RulesMixin, ServiceMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {
          produtoServicoCategoria: '',
          listaValoresGrade,
        };
      },
    },
  },
  data: (vm) => ({
    requestClass: ProdutoGradeRequest,
    dddOptions: vm.transformItemsToSelect(Ddds),
    ddds: vm.setDdds(vm.value.listaValoresGrade),
    gradeSwal: {
      successMessage: 'Sucesso ao tentar salvar a grade valores!',
      errorMessage: 'Falha ao tentar salvar a grade valores!',
    },
    removeItens: [],
  }),
  computed: {
    items() {
      const initialItems = this.value.listaValoresGrade;

      if (!initialItems.length) {
        this.addItem();
      }
      return initialItems;
    },
    defineCols() {
      return (col = '3', noIsRoCol = '5') => (this.isRo ? col : noIsRoCol);
    },
    getId() {
      return this.$route.params.id;
    },
    isRo() {
      return this.value.produtoServicoCategoria === 'RECARGA_ONLINE';
    },
  },
  created() {
    this.save();
  },
  methods: {
    addItem() {
      this.value.listaValoresGrade.push(
        {
          ...itemListaValor,
          idProdutoServico: this.getId,
        },
      );
    },
    removeItem(idx) {
      this.ifIsRoRemoveDdd(idx);
      this.value.listaValoresGrade.splice(idx, 1);
    },
    ifIsRoRemoveDdd(idx) {
      this.removeItens.push(
        this.items[idx].id,
      );
    },
    transformItemsToSelect(items = []) {
      return items.map(
        (item) => ({
          value: item,
          text: item,
        }),
      );
    },
    makeDddsContent(items = itemListaValor.produtoServicoGradeDdds, item) {
      return items.map(
        ({ ddd }) => this.makeDddBody(ddd, item),
      );
    },
    makeDddBody(ddd, item) {
      return {
        value: ddd,
        text: ddd,
        item,
      };
    },
    setDdds(items = []) {
      return items.map(
        (item) => this.makeDddsContent(
          item.produtoServicoGradeDdds,
          item,
        ),
      );
    },
    save() {
      this.$root.$on(
        'save-update-grade',
        (value) => {
          if (value) {
            this.makeRequest();
          }
        },
      );
    },
    makeRequest() {
      this.callService(
        this.prepareRequest(
          this.prepareGrade(),
        ),
        null,
        this.gradeSwal,
      );
    },
    manualRequest() {
      return this.prepareRequest(
        this.prepareGrade(),
      );
    },
    prepareRequest(grade) {
      return Promise.all([
        ...this.updateGrade(
          grade.filter(
            (item) => item.id,
          ),
        ),
        ...this.saveGrade(
          grade.filter(
            (item) => !item.id,
          ),
        ),
        ...this.removeDdds(),
      ]).then(
        (response) => ({
          data: response,
        }),
      );
    },
    removeDdds() {
      if (this.removeItens.length) {
        return this.removeItens.map(
          (id) => this.requestClass.remove(id),
        );
      }
      return [
        Promise.resolve(),
      ];
    },
    updateGrade(items) {
      return items.map(
        (item) => this.requestClass.edit(
          item.id,
          {
            ...item,
          },
        ),
      );
    },
    saveGrade(items) {
      return items.map(
        (item) => this.requestClass.save({
          ...item,
        }),
      );
    },
    prepareGrade() {
      return this.items.map(
        (item, idx) => ({
          ...this.makeItemBody(item, idx),
        }),
      );
    },
    makeItemBody(item, idx) {
      return {
        ...item,
        produtoServicoGradeDdds: this.prepareToSaveDdd(
          this.ddds[idx],
        ),
      };
    },
    prepareToSaveDdd(items) {
      return this.isArray(items) ? items.map(
        (item) => {
          if (item && item.value) {
            return {
              ddd: item.value,
            };
          }
          return '';
        },
      ).filter(
        (item) => item !== '',
      ) : [];
    },
    isArray(item) {
      return Array.isArray(item) && item.length >= 1;
    },
  },
};
</script>
